import { getFromUrls } from '@gef-ui/redux-common/selectors/urls';
import { TOKEN } from '../../constants';
import revokeAuthorizationTokens from '../revokeAuthorizationTokens';
/**
 * Handles standard oauth2 logout flow. Removes tokens from localStorage and revokes them
 *
 * @documented
 * @category Action
 * @example
 *
 * 	dispatch(logout());
 *
 */ export default ((logoutHandler, clearLocalStorage, accessTokenLocalStorageKey = TOKEN.ACCESS_TOKEN_KEY, refreshTokenLocalStorageKey = TOKEN.REFRESH_TOKEN_KEY)=>async (dispatch, getState)=>{
        if (clearLocalStorage) {
            localStorage.removeItem(refreshTokenLocalStorageKey);
            localStorage.removeItem(accessTokenLocalStorageKey);
        }
        await dispatch(revokeAuthorizationTokens);
        if (logoutHandler) {
            logoutHandler();
        } else {
            return window.location.replace(getFromUrls('logout')(getState()));
        }
    });
